// extracted by mini-css-extract-plugin
module.exports = {"container":"a10a3f92e9--container--lr33m","coworking-profit-banner":"a10a3f92e9--coworking-profit-banner--Km3kt"};